export const EMAIL_RESTRICTION_MODE = Object.freeze({
  BLOCK_FREE_DOMAINS: 'block_free_domains',
  ALLOW_SPECIFIC_DOMAINS: 'allow_specific_domains',
})
